const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/paywall_payment_settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/paywall_payment_settings")({
  beforeLoad: ({
    context
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const isPaywallPaymentSettingsAvailable = !!currentCommunity?.policies?.is_paywall_payment_settings_available;
    if (!isPaywallPaymentSettingsAvailable) {
      redirect({
        to: "/settings/paywalls",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});